<template>
  <div>
    <vessel-crew-table :id="id"></vessel-crew-table>
  </div>
</template>

<script>
import VesselCrewTable from '@/components/tables/VesselCrewTable.vue'

export default {
  name: 'VesselCrew',
  components: {
    VesselCrewTable
  },
  props: {
    id: String
  }
}
</script>

<style scoped></style>
